hasMergeFunction_1